import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconColumnChart({
  onClick,
  isAutoscallable = true,
  sizeKey = '32x32',
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconCompetencies', { 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.875 30.25C27.875 30.5484 27.7565 30.8345 27.5455 31.0455C27.3345 31.2565 27.0484 31.375 26.75 31.375H13.25C12.9516 31.375 12.6655 31.2565 12.4545 31.0455C12.2435 30.8345 12.125 30.5484 12.125 30.25C12.125 29.9516 12.2435 29.6655 12.4545 29.4545C12.6655 29.2435 12.9516 29.125 13.25 29.125H26.75C27.0484 29.125 27.3345 29.2435 27.5455 29.4545C27.7565 29.6655 27.875 29.9516 27.875 30.25ZM15.125 25.75V12.25C15.125 11.7527 15.3225 11.2758 15.6742 10.9242C16.0258 10.5725 16.5027 10.375 17 10.375H23C23.4973 10.375 23.9742 10.5725 24.3258 10.9242C24.6775 11.2758 24.875 11.7527 24.875 12.25V25.75C24.875 26.2473 24.6775 26.7242 24.3258 27.0758C23.9742 27.4275 23.4973 27.625 23 27.625H17C16.5027 27.625 16.0258 27.4275 15.6742 27.0758C15.3225 26.7242 15.125 26.2473 15.125 25.75ZM17.375 25.375H22.625V12.625H17.375V25.375Z"
        fill="#DEC7FA"
      />
    </svg>
  );
}
